// extracted by mini-css-extract-plugin
export default {"noDesktop":"no-desktop_noDesktop__aPYdb","icon":"no-desktop_icon__zMs3c","opacity-transition":"no-desktop_opacity-transition__1FLvA"};